/**
 * Gate 4 — organization_id rollout registry (schema only).
 * Application query scoping is Gate 5. RLS is Gate 6.
 *
 * RG-04 Phase B: organization_id is required on tenant-owned tables.
 * Catalog tables use catalog_scope_enum (platform | organization).
 */

export const GATE4_MIGRATION_ORDER = Object.freeze([
  "20260802115000_org_v1_gate4_project_id_alignment.sql",
  "20260802120000_org_v1_gate4_organization_id_rollout.sql",
  "20260816120000_rg04_organization_id_integrity_phase_a.sql",
  "20260818120000_rg04_phase_b_ownership_model.sql",
]);

/**
 * Legacy tables that required project_id text→uuid alignment before Gate 4 joins.
 */
export const GATE4_PROJECT_ID_ALIGNMENT_TABLES = Object.freeze([
  "time_logs",
  "active_sessions",
]);

export const GATE4_ROLLOUT_TABLES = Object.freeze([
  "clients",
  "projects",
  "materials",
  "time_logs",
  "payroll_rates",
  "active_sessions",
  "trades",
  "classifications",
  "payroll_types",
  "work_types",
  "work_type_templates",
  "estimates",
  "invoices",
  "project_material_usage",
  "feature_types",
  "assembly_templates",
  "estimate_events",
  "estimate_conversion_events",
]);

/**
 * Tenant-owned organization_id columns are NOT NULL after RG-04 Phase B.
 * Platform catalog rows remain null-org by ownership rule (catalog_scope=platform).
 */
export function isOrgRolloutColumnOptional() {
  return false;
}
